import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Tooltip } from "antd";
import { navigationService } from "../../services/navigationService";
import {
  UserGroupIcon,
  CogIcon,
  ChatAlt2Icon,
} from "@heroicons/react/outline";

import {
  LogoContainer,
  LogoShapeContainer,
  LogoShape,
  UserSection,
  LogoUserWrapper,
  SidebarContainer,
  LibraryIconButton,
  SidebarContent,
  SidebarItemWrapper,
  MainNavigation,
  BottomSection,
  NavLinks,
  NavLinkContent,
  NavLink
} from "./Sidebar.styles";


interface SidebarProps {
  onLogoClick?: () => void;
  creatorExtensionOpen?: boolean;
  onCreatorExtensionToggle?: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ onLogoClick, creatorExtensionOpen = false, onCreatorExtensionToggle }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleCreatorClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onCreatorExtensionToggle?.();
  };

  const handleManagersClick = () => {
    navigate('/manager');
  };

  // Navigation helpers using navigation service
  const isLinkActive = (linkTo: string): boolean => {
    return navigationService.isActive(location.pathname, linkTo);
  };

  return (
    <SidebarContainer>
      {/* No handle needed for fixed sidebar */}

      <SidebarContent>
        {/* Logo Section */}
        <UserSection>
          <LogoUserWrapper>
            <LogoContainer onClick={onLogoClick || (() => navigate("/"))}>
              <LogoShapeContainer>
                <LogoShape $variant="secondary" />
                <LogoShape $variant="primary" />
              </LogoShapeContainer>
            </LogoContainer>
          </LogoUserWrapper>
        </UserSection>

        <MainNavigation>
          {/* Creator Library */}
          <NavLinks>
            <Tooltip title="Creator Library" placement="right">
              <SidebarItemWrapper $isClickable={true}>
                <LibraryIconButton 
                  $isActive={creatorExtensionOpen}
                  onClick={handleCreatorClick}
                  title="Creator Library"
                >
                  <UserGroupIcon />
                </LibraryIconButton>
              </SidebarItemWrapper>
            </Tooltip>

            {/* Managers */}
            {/* <Tooltip title="Campaign Managers" placement="right">
              <SidebarItemWrapper $isClickable={true}>
                <LibraryIconButton 
                  $isActive={location.pathname.startsWith('/manager')}
                  onClick={handleManagersClick}
                  title="Campaign Managers"
                >
                  <ChatAlt2Icon />
                </LibraryIconButton>
              </SidebarItemWrapper>
            </Tooltip> */}
          </NavLinks>
        </MainNavigation>

        <BottomSection>
          {/* Settings */}
          <NavLinks>
            <Tooltip title="Settings" placement="right">
              <SidebarItemWrapper $isClickable={true}>
                <NavLink
                  to="/settings"
                  $isActive={isLinkActive("/settings")}
                >
                  <NavLinkContent $isActive={isLinkActive("/settings")}>
                    <CogIcon />
                    <span>Settings</span>
                  </NavLinkContent>
                </NavLink>
              </SidebarItemWrapper>
            </Tooltip>
          </NavLinks>
        </BottomSection>
      </SidebarContent>
    </SidebarContainer>
  );
}; 
